<template>
    <div class="container mt-5">
        <div class="row">
            <div class="col-12">
                <h4 class="section-title">Tips på artiklar</h4>
            </div>
            <div :key="`article_${article.id}`" class="col-12 col-md-4 col-lg-3" v-for="article in articles">
                <result-item ref="articles" :item="article" type="article" />
            </div>
            <div class="col-12">
                <h4 class="section-title">Tips på platser</h4>
            </div>
            <div :key="`location_${location.id}`" class="col-12 col-md-4 col-lg-3" v-for="location in locations">
                <result-item ref="locations" :item="location" type="location" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SearchWelcome',

  computed: {
    ...mapState({
      articles: state => state.search.popular.articles,
      locations: state => state.search.popular.locations
    })
  }
}
</script>

<style scoped>

</style>
